import { render, staticRenderFns } from "./Carriers.vue?vue&type=template&id=6d4ea550&"
import script from "./Carriers.vue?vue&type=script&lang=js&"
export * from "./Carriers.vue?vue&type=script&lang=js&"
import style0 from "./Carriers.vue?vue&type=style&index=0&id=6d4ea550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarrierCard: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CarrierCard.vue').default})
